import React, { useState } from 'react';
import { LandingView } from './components/LandingView';
import { QuizView } from './components/QuizView';
import { ResultView } from './components/ResultView';
import { FORMAL_QUESTIONS, MOCK_RESULTS } from './data/mockQuizData';
import { QuizResult } from './types';
import {
  calculateRawScores,
  normalizeScores,
  matchCharacter,
  generateResultViewData,
  MatchResult,
} from './utils/scoringEngine';

type QuizState = 'landing' | 'quiz' | 'result';

export const App: React.FC = () => {
  const [state, setState] = useState<QuizState>('landing');
  const [result, setResult] = useState<QuizResult>(MOCK_RESULTS.naiwa);
  const [lastMatch, setLastMatch] = useState<MatchResult | null>(null);

  const handleStart = () => {
    setState('quiz');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleQuizComplete = (answers: Record<number, string>) => {
    // 接入正式 12D 评分、分流与角色加权距离匹配
    const rawScores = calculateRawScores(answers);
    const normalized12D = normalizeScores(rawScores);
    const match = matchCharacter(normalized12D, rawScores);
    const dynamicResult = generateResultViewData(match);

    setLastMatch(match);
    setResult(dynamicResult);
    setState('result');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleRestart = () => {
    setState('landing');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#E5E0D8] flex justify-center items-center sm:py-6 font-sans">
      {/* 手机外框容器：大屏呈现精致的手机档案感视窗，真机全屏自适应 */}
      <div className="w-full max-w-md min-h-[100dvh] sm:min-h-[844px] bg-paper-50 sm:border-3 sm:border-ink-950 sm:shadow-dossier-lg relative overflow-hidden flex flex-col justify-between">
        {state === 'landing' && <LandingView onStart={handleStart} />}
        {state === 'quiz' && (
          <QuizView
            questions={FORMAL_QUESTIONS}
            onComplete={handleQuizComplete}
            onBackToLanding={() => setState('landing')}
          />
        )}
        {state === 'result' && (
          <ResultView
            initialResult={result}
            matchResult={lastMatch}
            onRestart={handleRestart}
          />
        )}
      </div>
    </div>
  );
};

export default App;
